import React from 'react'

export default function CardContainer(props) {
  const {
    header,
    headerKind = 'filled',
    headerTheme = 'primary',
    body,
    bodyClassName='',
    footer,
    footerClassName='',
    className='',
    isClickable = false,
    rounded = true,
    isCard = true
  } = props

  const roundedClasses = rounded ? 'rounded-md' : ''
  const cardClasses = isCard ? 'shadow-md' : ''


  const renderHeaderFilled = () => {
    return (
      <div className={`bg-${headerTheme}-900 text-white p-4`}>
        {header}
      </div>
    )
  }

  const renderHeaderBorderTop = () => {
    return (
      <div className={`border-t-3 border-${headerTheme}-900 pt-2 pb-2 px-2 bg-white`}>
        {header}
      </div>

    )
  }

  const renderHeader = () => {
    if (headerKind == "borderTop") return renderHeaderBorderTop()
    return renderHeaderFilled()
  }

  return (
    <div 
      className={`${className} ${isClickable ? 'hover:shadow-lg': ''} ${cardClasses} overflow-hidden ${roundedClasses} w-full`}>

      {/* Header */}
      {header && (
        renderHeader()
      )}

      {/* Body */}
      {body && (
        <div className={`h-full ${bodyClassName}`}>
          {body}
        </div>
      )}

      {/* Footer */}
      {footer && (
        <div className={`${footerClassName}`}>
          {footer}
        </div>
      )}
    </div>
  )
}
